module.exports = __webpack_public_path__ + "img/carousel-productos-10.1a739d1e.jpg";